<template>
  <div>
    <vs-popup title="Confirmar" :active.sync="modal_confirm">
      <div style="font-size: 2.2vh; text-align: center" class="mb-8 text-warning">
        Está seguro de guardar los registros seleccionados:
        <b> {{ cobranza_selecteds.reduce((acc, row) => acc + (row.total_registros || 0), 0) | numberFormat }}</b>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 justify-center items-center mb-12">
        <div>
          <span>Seleccione una empresa</span>
          <v-select class="w-full style-chooser" v-model="company_selected" label="com_name" :options="companies"
            :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="search_users()" />
        </div>
        <div>
          <span>Seleccione un gestor</span>
          <v-select class="w-full style-chooser" v-model="user_selected" label="names" :options="users"
            :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
        <div class="col-span-2 flex flex-col gap-2">
          <span>Nota</span>
          <textarea style="background: #f2f2f2; color: #9d9d9d" v-model="gnc_note" placeholder="Agregar Nota"
            class="w-full rounded-xl p-5 border-none shadow-lg"></textarea>
        </div>
      </div>

      <div class="mb-12 flex justify-center">
        <vs-checkbox v-model="confirm_mail">
          <b>¿Enviar correo al cliente?</b>
        </vs-checkbox>
      </div>

      <vs-button @click="save_cobranzas_selected" class="w-full mb-2">Guardar</vs-button>
    </vs-popup>
    <div style="
        display: flex;
        gap: 20px;
        justify-content: end;
        align-items: center;
      ">
      <vs-button class="p-2" color="success" @click="exportToXLSX">Exportar XLSX</vs-button>
    </div>

    <vs-table v-if="data_cobranza.length > 0" stripe pagination :max-items="items_table" search :data="data_cobranza">
      <template slot="header">
        <vs-button icon-pack="feather" icon="icon-save" color="primary" class="px-2 py-3" @click="modal_confirm = true"
          :disabled="cobranza_selecteds.length === 0">Guardar
          seleccionados</vs-button>
        <select class="select_pagination" sty v-model="items_table">
          <option selected value="5">5</option>
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </template>
      <template slot="thead">
        <vs-th>
          <div class="leading-1">Todos<vs-checkbox @input="checkAll()"></vs-checkbox></div>
        </vs-th>
        <vs-th sort-key="Segmentacion">Segmentación</vs-th>
        <vs-th sort-key="Tipo_cuenta">Tipo Cuenta</vs-th>
        <vs-th sort-key="Antiguedad">Antiguedad</vs-th>
        <vs-th sort-key="total_registros">Total Cuentas</vs-th>
        <vs-th sort-key="saldo_total">Saldo Total</vs-th>
        <vs-th sort-key="Estado_email">Estado email</vs-th>
        <!-- <vs-th sort-key="tag">Tag</vs-th> -->
        <!-- <vs-th sort-key="gcc_created_at">Fecha asignación</vs-th> -->
        <!-- <vs-th><div class="leading-1">Todos<vs-checkbox @input="checkAll()"></vs-checkbox></div></vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" style="cursor: pointer; text-align: center">
          <vs-td>
            <vs-checkbox v-model="cobranza_selecteds" :vs-value="tr"></vs-checkbox>
          </vs-td>
          <vs-td>
            {{ tr.Segmentacion }}
          </vs-td>
          <vs-td>{{ tr.Tipo_cuenta }}</vs-td>
          <vs-td>{{ tr.Antiguedad }}</vs-td>
          <vs-td>{{ tr.total_registros | numberFormat }}</vs-td>
          <vs-td>{{ tr.saldo_total | currency }}</vs-td>
          <vs-td>{{ tr.Estado_email }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import axios from "@/axios";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import traducciones_json from "../../traducciones.json";
export default {
  components: {},
  props: {
    data_cobranza: {
      type: Array,
      default: [],
    },
    companies: {
      type: Array,
      default: [],
    },
    min_range: {
      type: [Number, String],
      default: 0,
    },
    max_range: {
      type: [Number, String],
      default: 0,
    },
    search_filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      config: null,
      cobranza_selecteds: [],
      traducciones: traducciones_json,
      items_table: 5,
      collectors_modal: false,
      client_selected: {},
      user_session: {},
      collectors: [],
      modal_confirm: false,
      company_selected: null,
      user_selected: null,
      users: [],
      gnc_note: "",
      confirm_mail: false,
    };
  },
  mounted() {
    this.config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.accessToken,
      },
    };

    this.user_session = localStorage.user_session
      ? JSON.parse(localStorage.user_session)
      : {};
  },

  methods: {
    exportToXLSX() {
      const XLSX = require("xlsx");
      // Crear una hoja de trabajo a partir de los datos
      const worksheet = XLSX.utils.json_to_sheet(this.data_cobranza);

      // Obtener el rango de encabezados de la hoja de trabajo
      const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);

      // Crear un objeto de traducciones para los encabezados
      const translationMap = this.traducciones.reduce((map, item) => {
        map[item.en] = item.es;
        return map;
      }, {});

      // Reemplazar los encabezados en la hoja de trabajo con las traducciones
      for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
        const columnHeader = XLSX.utils.encode_col(col) + "1";
        if (worksheet[columnHeader]) {
          // Reemplazar el encabezado con la traducción correspondiente
          const originalHeader = worksheet[columnHeader].v;
          worksheet[columnHeader].v =
            translationMap[originalHeader] || originalHeader;
        }
      }

      // Crear un libro nuevo y agregar la hoja de trabajo
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

      // Convertir el libro a un buffer y guardar el archivo
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(data, "datos.xlsx");
    },
    search_collectors() {
      let param_query = this.client_selected.panapass ? this.client_selected.panapass : this.client_selected.currentOwnerDocumentNumber;
      axios
        .get(`/auth/get_collectors_client/${this.client_selected.plate}/${param_query}`)
        .then((response) => {
          this.collectors = response.data;
        });
      this.collectors_modal = true;
    },
    search_users() {
      this.$vs.loading();
      let me = this;
      axios
        .get(
          `auth/getUsersCompany/${this.company_selected.com_id}`,
          this.config
        )
        .then(function (response) {
          me.users = response.data;

          me.$vs.loading.close();
        })
        .catch(function (error) {
          me.$vs.loading.close();
        });
    },
    async save_cobranzas_selected() {
      let me = this;

      if (this.cobranza_selecteds.length == 0) {
        this.$vs.notify({
          title: "Alerta",
          text: "Seleccione almenos un registro",
          color: "warning",
          iconPack: "feather",
          icon: "icon-alert-triangle",
          position: "top-center",
        });
        return;
      }
      if (this.user_selected.length == 0) {
        this.$vs.notify({
          title: "Alerta",
          text: "Seleccione un gestor",
          color: "warning",
          iconPack: "feather",
          icon: "icon-alert-triangle",
          position: "top-center",
        });
        return;
      }

      this.$vs.loading();
      // Lógica para enviar correos a los seleccionados
      const data = this.cobranza_selecteds.map(item => ({
        Segmentacion: item.Segmentacion,
        Tipo_cuenta: item.Tipo_cuenta,
        Antiguedad: item.Antiguedad,
        Estado_email: item.Estado_email
      }));
      const body = {
        data,
        user: this.user_selected.id,
        email: this.user_selected.email,
        user_name: this.user_selected.names,
        confirm_mail: this.confirm_mail ? 1 : 0,
        gcc_note: this.gnc_note,
        filters: this.search_filters,
      };

      await axios
        .post(`auth/save_cobranzas_selected_grouped`, body, this.config)
        .then(function (response) {
          if (response.data == 1) {
            body.confirm_mail
              ? Swal.fire({
                title:
                  "¡Éxito! Registros seleccionados guardados exitosamente",
                text: "Recibiras un correo de confirmación cuando se hayan enviado todos los email de contacto a los clientes seleccionados.",
                icon: "success",
              })
              : Swal.fire({
                title:
                  "¡Éxito! Registros seleccionados guardados exitosamente",
                icon: "success",
              });
          } else {
            Swal.fire({
              title: "Alerta!",
              text: response.data,
              icon: "info",
            });
          }
          me.cobranza_selecteds = [];
          me.$emit("search_cobranza");

          me.modal_confirm = false;
          me.$vs.loading.close();
        })
        .catch(function (error) {
          Swal.fire({
            title: "¡Error!",
            text: "Error al guardar registros seleccionados" + error,
            icon: "danger",
          });
          me.$vs.loading.close();
        });
    },
    checkAll() {
      if (this.cobranza_selecteds.length === this.data_cobranza.length) {
        this.cobranza_selecteds = [];
      } else {
        this.cobranza_selecteds = [...this.data_cobranza];
      }
    }
  },
};
</script>
<style lang="scss" scoped></style>
